import { C as k, a as j, A as S, c as _ } from "../../Avatar.skeleton-B5u-Jikt.js";
import { b as aa, d as ra, e as sa, f as ea, g as oa } from "../../Avatar.skeleton-B5u-Jikt.js";
import { j as a, c as i } from "../../utils-BdNIfrGQ.js";
import { t as I } from "../../BaseTypography.styles-D7he6cFf.js";
import { C as V } from "../../collapsible-DacB5xWd.js";
import { n as u } from "../../normalize-spacing-DY0KSpr_.js";
import { S as f } from "../../skeleton-CpjuZTJp.js";
import { T as p } from "../../Text-BhLXzYEf.js";
import { D as e } from "../../Div-spVpsZsH.js";
import { D as E } from "../../Div.skeleton-DLnqOZrU.js";
import { F as x } from "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
import { useState as g, useEffect as F } from "react";
import { B as T } from "../../Button.skeleton-D0Onk1OP.js";
import { I as D } from "../../Image-Ct1HaCUq.js";
const Q = ({
  size: r = "xl",
  fontWeight: o = "bold",
  ...s
}) => /* @__PURE__ */ a.jsx(k, { className: i(I({ size: r, fontWeight: o })), ...s }), U = ({
  defaultOpen: r = !1,
  onOpenChange: o,
  open: s,
  spacing: n,
  header: c,
  children: t,
  ...l
}) => {
  const d = { ...c, collapsible: !0, open: s };
  return /* @__PURE__ */ a.jsx(
    V,
    {
      className: i(u(n), "w-full"),
      defaultOpen: r,
      onOpenChange: o,
      open: s,
      children: /* @__PURE__ */ a.jsx(j, { header: d, ...l, children: t })
    }
  );
}, W = ({
  spacing: r = "2 2",
  height: o,
  header: s,
  avatar: n,
  footer: c,
  children: t
}) => {
  const l = t || /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(f, { className: i("leading-5"), grayVariant: 300, children: /* @__PURE__ */ a.jsx(p, {}) }),
    /* @__PURE__ */ a.jsx(f, { className: i("leading-5"), grayVariant: 300, children: /* @__PURE__ */ a.jsx(p, {}) })
  ] });
  return /* @__PURE__ */ a.jsxs(
    E,
    {
      spacing: r,
      "data-testid": "card-skeleton",
      className: i(
        _({ height: o }),
        u(r),
        "flex gap-7 flex-col p-7 rounded-xl"
      ),
      children: [
        s && /* @__PURE__ */ a.jsxs(x, { gap: "2", children: [
          n && /* @__PURE__ */ a.jsx(S, { spacing: "2", grayVariant: 300 }),
          /* @__PURE__ */ a.jsx(f, { className: i(u(r), "w-2/3"), grayVariant: 300, children: /* @__PURE__ */ a.jsx(p, {}) })
        ] }),
        l,
        c && /* @__PURE__ */ a.jsx(x, { gap: "2", className: "w-full flex-row justify-end", children: /* @__PURE__ */ a.jsx(T, { variant: "outline", grayVariant: 200 }) })
      ]
    }
  );
}, X = ({ image: r, children: o, spacing: s, badge: n, shadow: c }) => {
  const [t, l] = g(!1), [d, m] = g(!1);
  F(() => {
    l(!1), m(!1);
  }, [r?.src]);
  const h = () => {
    l(!0), m(!1);
  }, y = () => {
    l(!1), m(!0);
  }, v = "bg-[radial-gradient(circle_at_95%_5%,_var(--tw-gradient-stops))] from-secondary/60 via-secondary/10 to-transparent group-hover:from-secondary/40 group-active:from-secondary/40 group-focus:from-secondary/40 h-full w-full absolute", b = "bg-[radial-gradient(circle_at_5%_95%,_var(--tw-gradient-stops))] from-secondary/80 via-secondary/10 via-transparent via-transparent to-transparent group-hover:from-secondary/40 group-active:from-secondary/40 group-focus:from-secondary/40 h-full w-full absolute", C = "bg-gradient-to-b from-primary to-primary/20 group-hover:from-primary/80 group-active:from-primary/80 group-focus:from-primary/80 h-full w-full absolute", N = () => /* @__PURE__ */ a.jsxs(e, { "data-testid": "fallback-gradient", className: "relative h-full w-full", children: [
    /* @__PURE__ */ a.jsx(e, { className: C }),
    /* @__PURE__ */ a.jsx(e, { className: v }),
    /* @__PURE__ */ a.jsx(e, { className: b })
  ] }), w = !r || !t || d;
  return /* @__PURE__ */ a.jsxs(j, { spacing: s, shadow: c, children: [
    /* @__PURE__ */ a.jsxs(e, { className: "relative -mt-7 -mx-7 mb-7", children: [
      r && /* @__PURE__ */ a.jsx(
        e,
        {
          className: `${t ? "opacity-100" : "opacity-0"} w-full h-auto`,
          style: { transition: "opacity 0.3s ease-in-out" },
          children: /* @__PURE__ */ a.jsx(
            D,
            {
              src: r.src,
              alt: "",
              variant: "full",
              onLoad: h,
              onError: y
            }
          )
        }
      ),
      w && /* @__PURE__ */ a.jsx(e, { className: "h-[200px] w-auto", children: /* @__PURE__ */ a.jsx(N, {}) }),
      n && /* @__PURE__ */ a.jsx(e, { className: "absolute bottom-0 right-0 p-5", children: n })
    ] }),
    o
  ] });
};
export {
  j as Card,
  aa as CardContent,
  ra as CardFooter,
  sa as CardHeader,
  W as CardSkeleton,
  Q as CardTitle,
  U as CollapsibleCard,
  ea as CollapsibleContent,
  oa as CollapsibleTrigger,
  X as ImageCard
};
